import { useSession } from '@/entities/session';
import { ErrorBoundary, Loading } from '@/shared/ui';
import { backgroundPrimary } from '@filament/react/atomic-styles';
import { base } from '@filament/react/base-styles';
import '@filament/react/fonts/latin';
import { RouterProvider } from '@filament/react/router';
import { blue } from '@filament/react/themes/blue.css';
import { light } from '@filament/react/themes/light.css';
import { medium } from '@filament/react/themes/medium.css';
import clsx from 'clsx';
import { ReactNode } from 'react';
import { useNavigate, useRoutes } from "react-router-dom";
import { QueryProvider } from './providers/QueryProvider';
import { SessionProvider } from './providers/session/SessionProvider';
import { routes } from './routes';

const GlobalLoadingGuard = ({ children }: { children: ReactNode }) => {
    const { status } = useSession();

    if (status === 'loading') {
        return <Loading text="Loading App..." fullScreen />;
    }

    return <>{children}</>;
};


export const App = () => {
    const routeItems = useRoutes(routes);
    const navigate = useNavigate();

    return (
        <div className={clsx(blue, light, medium, base, backgroundPrimary)}>
            <QueryProvider>
                <SessionProvider>
                    <GlobalLoadingGuard>
                        <ErrorBoundary>
                            <RouterProvider navigate={navigate}>
                                {routeItems}
                            </RouterProvider>
                        </ErrorBoundary>
                    </GlobalLoadingGuard>
                </SessionProvider>
            </QueryProvider>
        </div >
    );
};
